import { render, staticRenderFns } from "./AtosInfralegaisPorEnteFederativoPorOrgao.vue?vue&type=template&id=569f2334&scoped=true"
import script from "./AtosInfralegaisPorEnteFederativoPorOrgao.vue?vue&type=script&lang=js"
export * from "./AtosInfralegaisPorEnteFederativoPorOrgao.vue?vue&type=script&lang=js"
import style0 from "./AtosInfralegaisPorEnteFederativoPorOrgao.vue?vue&type=style&index=0&id=569f2334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f2334",
  null
  
)

export default component.exports